import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree, CanActivateChild, CanLoad, Route } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable()
// export class AuthGuard implements CanActivate {
//   roleId: string;


//   constructor(private authService: AuthService, private router: Router) { }




  
 

//   canActivate(route: ActivatedRouteSnapshot,
//               state: RouterStateSnapshot): boolean|UrlTree {
//
//       console.log('canActivate on '+route.url);

//       if (!this.authService.loggedIn()) {
        
//           this.router.navigate(['/Select']);
//           return false;

//           //var urlTree = this.router.createUrlTree(['login']);
//           //return urlTree;
//       } 

//       return true;
//   }

// //   canActivateChild(route: ActivatedRouteSnapshot,
// //                   state: RouterStateSnapshot): boolean|UrlTree {


      
// //       if (!this.authService.isAdminUser()) {
// //           alert('You are not allowed to view this page');
// //           return false;
// //       }


// //       return true;
// // }
// }
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.checkLogin(state.url)) {
      return true
    }
    return false
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state)
  }

  canLoad(route: Route): boolean {
    const url = `/${route.path}`

    return this.checkLogin(url)
  }

  private checkLogin(url: string): boolean {
    if (this.authService.isAuthenticated()) {
      return true
    }

    this.authService.redirectUrl = url

    this.router.navigate([ '/Select' ])
    return false
  }
}
